export default {
  inserted(el, binding, vnode) {
    vnode.context.resizeTable(el, vnode)
    // resizable(el, vnode);
    // window.addEventListener('resize', () => {
    //   resizable(el, vnode)
    // });
  },
}